import axios from 'axios';
import {
    authHeader
} from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class DepartmentService {
    listDepartement() {
        return axios.get(API_URL + 'department', {
            headers: authHeader()
        });
    }
    addDepartement(data) {
        return axios.post(API_URL + 'department', data, {
            headers: authHeader()
        });
    }
    editDepartement(id, data) {
        return axios.patch(API_URL + 'department/'+id, data, {
            headers: authHeader()
        });
    }
    deleteDepartement(id) {
        return axios.delete(API_URL + 'department/' + id, {
            headers: authHeader()
        });
    }
}

export default new DepartmentService();